
import React from 'react';

const EvolutionOfITNeeds: React.FC = () => {
  return (
    <>
      <h2 className="text-2xl font-bold mb-4 mt-8 text-itmgmt-dark-blue">The Evolution of Business IT Needs</h2>
      <p className="mb-6 text-gray-700 leading-relaxed">
        Before diving into specific models, it helps to understand how technology requirements typically evolve as businesses grow:
      </p>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div className="border border-gray-200 rounded-lg p-5 shadow-sm">
          <h3 className="text-lg font-semibold mb-3 text-itmgmt-medium-blue">Startup Stage</h3>
          <ul className="list-disc ml-5 text-gray-700 text-sm space-y-2">
            <li>Basic infrastructure setup</li>
            <li>Cost-sensitive decisions</li>
            <li>Limited in-house expertise</li>
            <li>Cloud-first approach common</li>
            <li>Flexibility for rapid changes</li>
          </ul>
        </div>
        <div className="border border-gray-200 rounded-lg p-5 shadow-sm">
          <h3 className="text-lg font-semibold mb-3 text-itmgmt-medium-blue">Growth Stage</h3>
          <ul className="list-disc ml-5 text-gray-700 text-sm space-y-2">
            <li>Increasing system complexity</li>
            <li>Growing security concerns</li>
            <li>Need for scalable solutions</li>
            <li>Business continuity importance</li>
            <li>Compliance requirements emerge</li>
          </ul>
        </div>
        <div className="border border-gray-200 rounded-lg p-5 shadow-sm">
          <h3 className="text-lg font-semibold mb-3 text-itmgmt-medium-blue">Maturity Stage</h3>
          <ul className="list-disc ml-5 text-gray-700 text-sm space-y-2">
            <li>Complex IT environments</li>
            <li>Multiple locations/remote workforce</li>
            <li>Strategic technology alignment</li>
            <li>Advanced security posture</li>
            <li>Digital transformation initiatives</li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default EvolutionOfITNeeds;
